import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@/assets/icons/ArrowRightIcon';
import { ROUTES } from '@/lib/constants/routes';

/**
 * Free-tier, no-entity-yet nudge to start the create-startup wizard. Shown
 * only for that persona/tier combination - see `DashboardPage`'s
 * `showUnlockBanner` gate.
 */
export function UnlockFeaturesBanner() {
  return (
    <Link
      to={ROUTES.CREATE_STARTUP}
      className="flex h-[6.25rem] w-full items-center justify-between rounded-card border border-[rgba(0,25,40,0.07)] p-[2.0625rem] shadow-[var(--card-shadow)] transition-opacity hover:opacity-95"
      style={{
        backgroundImage:
          'linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%), linear-gradient(90deg, #001928 0%, #004EA7 100%)',
      }}
    >
      <div className="flex flex-col gap-1.5">
        <p className="text-[1.25rem] leading-[1.42rem] font-medium text-white">
          To unlock more features,
        </p>
        <p className="text-[1.5rem] leading-[1.42rem] font-semibold text-yellow">
          Create your Startup Profile
        </p>
      </div>
      <span className="flex size-[2.625rem] shrink-0 items-center justify-center rounded-full bg-green pl-0.5">
        <ArrowRightIcon size={16} className="text-white" />
      </span>
    </Link>
  );
}
